import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useTranslation } from '../hooks/useTranslation';
import { useTheme } from '../hooks/useTheme';
import { MessagesSquare, MessageSquareText, Globe } from 'lucide-react';

export const MissionPage = () => {
  const { t, language, changeLanguage } = useTranslation();
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="min-h-screen flex flex-col bg-background" data-testid="mission-page">
      <Header
        t={t}
        theme={theme}
        toggleTheme={toggleTheme}
        language={language}
        changeLanguage={changeLanguage}
      />

      <main className="flex-1">
        {/* Header Section - No background image */}
        <div className="bg-muted/30 py-16 sm:py-20">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center space-y-3 max-w-3xl mx-auto">
              <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight">
                {t('mission_title')}
              </h1>
              <p className="text-lg sm:text-xl text-muted-foreground">
                {t('mission_subtitle')}
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <div className="max-w-3xl mx-auto space-y-8">
            {/* Paragraph 1 - Breaking barriers */}
            <div className="flex gap-4 items-start p-6 border border-border rounded-sm bg-card">
              <div className="p-3 bg-secondary rounded-sm shrink-0">
                <MessagesSquare className="h-6 w-6 text-foreground" />
              </div>
              <p className="text-lg leading-relaxed text-foreground">
                {t('mission_p1')}
              </p>
            </div>

            {/* Paragraph 2 - Real-time transcription */}
            <div className="flex gap-4 items-start p-6 border border-border rounded-sm bg-card">
              <div className="p-3 bg-secondary rounded-sm shrink-0">
                <MessageSquareText className="h-6 w-6 text-foreground" />
              </div>
              <p className="text-lg leading-relaxed text-foreground">
                {t('mission_p2')}
              </p>
            </div>

            {/* Paragraph 3 - Free & accessible */}
            <div className="flex gap-4 items-start p-6 border border-border rounded-sm bg-card">
              <div className="p-3 bg-secondary rounded-sm shrink-0">
                <Globe className="h-6 w-6 text-foreground" />
              </div>
              <p className="text-lg leading-relaxed text-foreground">
                {t('mission_p3')}
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer t={t} />
    </div>
  );
};
